import { useDispatch } from 'react-redux'
import type { AppDispatch } from '../main'

export * from './useCopyToClipboard'
export * from './useCoreInfiniteScroll'
export * from './useCrossfadeViewMode'
export * from './useDepositPromoCode'
export * from './useDocumentRequestPopup'
export * from './useExpenseWorkflowCookie'
export * from './useFeatureFlag'
export * from './useHashTabNavigation'
export * from './useInfiniteScroll'
export * from './useLogoNavigation'
export * from './useMenuItems'
export * from './usePendingApprovalsTabVisibility'
export * from './usePopupModalDialog'
export * from './useRecipientsList'
export * from './useSearchParams'
export * from './useSorting'
export * from './useTkbFeeDiscount'
export * from './useWithdrawPromoCode'

export const useAppDispatch: () => AppDispatch = useDispatch
